const MB_SHIPS_HTML = `<div class="product__ships"></div>`; 
const SP_SPINNER_HTML = `
<div class="loading__spinner">
  <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
    <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
  </svg>
</div>`;

const RGX_PIPE_DELIM = /\s*\|\s*/;
const RGX_COMMA_DELIM = /\s*,\s*/;
const RGX_MULTI_SPACE = /\s\s+/g;

const BUYBAR_ATC_BUTTONS = {}; 

const DEFAULT_SWATCHES = {
  "Color": {
    "Black": { "color": "#000000", "image": null },
    "Blue": { "color": "#508bc1", "image": null },  
    "Light Blue": { "color": "#b6deff", "image": null },
    "Light Gray": { "color": "#e2e2e2", "image": null},
    "Olive Green": { "color": "#146b3b", "image": null}, 
    "Orange": { "color": "#FF8A00", "image": null},
    "Pink": { "color": "#FFC0CB", "image": null },
    "Purple": { "color": "#A54DCF", "image": null },
    "Red": { "color": "#F61F1F", "image": null },
    "White": { "color": "#FFFFFF", "image": null },
    "Yellow": { "color": "#FFE500", "image": null },
  }
}

const KFORM_PRODUCT_SIGNUP = "klaviyo-form-XwWic3"; 

const PRODUCT_INFO_BY_ID = {
  "7855973695569": {
    subtitle: "iPhone 17 Cases",
  },
  "7648774389841": {
    subtitle: "iPhone 16 Cases",
  },
  "7102371790929": {
    subtitle: "iPhone 15 Cases",
  },
  "15667812270161": {
    subtitle: "Samsung S26 Elite Case",
  },
  "7709995827281": {
    subtitle: "Samsung S25 Ultra Case",
  },
  "7688049688657": {
    subtitle: "Samsung S24 Ultra Case",
  },
  "3296634699857": {
    subtitle: "Car Charger &amp; Mount",
  },
  "7695572631633": {
    subtitle: "Smart Wallet",
  },
  "6706459377745": {
    subtitle: "3-in-1 MultiCharger",
  }
}; 


const _deepCopy = function(obj) {
  return obj ? JSON.parse(JSON.stringify(obj)) : obj;
}

const _dot = function(obj, key, val) {
  if (obj === undefined || obj === null ) { return; }
  if (Array.isArray(key)) { 
    let subkey = key[0]; 
    if (key.length > 1) { 
      let step = obj[subkey];  
      if (step === undefined && val !== undefined) { obj[subkey] = step = {}; }
      return _dot(step, key.slice(1), val) 
    } 
    if (val !== undefined) { obj[subkey] = val; }
    return obj[subkey];
  } else if (key !== undefined && key !== null && key.toString) {
    return _dot(obj, key.toString().split('.'), val);
  }
}

const _reg = function(obj, path, val, cbk) {
  let existing = _dot(obj,path);
  if (existing === undefined) {
    _dot(obj, path, val);
    if (cbk) { cbk(obj, path, val) }
    return val;
  }
  else {
    return existing;
  }
}

const _atm = function(arr, kcb, vcb) {
  const map = {}; 
  arr.forEach((item, i) => { 
    let key = kcb ? kcb(item, i) : item.toString();
    let val = vcb ? vcb(item, i) : item;
    if (!map[key]) { map[key] = val; }
  });
  return map 
}

const _last = function(arr) { 
  return arr ? arr[arr.length-1] : undefined;  
}

const _add = function(elem, tag, attrs={}) {
  let newElem = document.createElement(tag);
  elem.appendChild(newElem); 
  return _attr(newElem, attrs);
}

const _itr = function(obj, cbk) {
  if (!obj || !cbk) { return; }
  const keys = Object.keys(obj);
  for (let i = 0; i < keys.length; i++) {
    let key = keys[i];
    if (cbk(obj[key], key, obj[key], i) === false) { break; }
  }
}

const _attr = function(elem, attrs) {
  if (!elem || !attrs) { return; }
  if (attrs.cls && attrs.cls.split) {
    let ca = attrs.cls.split(/\s+/);
    elem.classList.add(...ca);
  }
  if (attrs.html) { elem.innerHTML = attrs.html; }
  Object.keys(attrs).forEach((key) => {
    if (key == 'cls') { return; }
    if (key == 'html') { return; }
    elem.setAttribute(key, attrs[key]);
  });
  return elem;
}

const isVideoPlaying = (video) => {
  return !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
}

const cleanVariantTitle = (title) => {
  if (!title) { return title; }
  let nameSet = new Set(title.split(" / "))
  return nameSet.size > 1 ? title : nameSet.values().next().value;
}

/*
 * 1LSS - MAGBAK REGULATOR 
**/
class Regulator {
    
  constructor() {
    this.productDataMap = {};
    this.init();
    this.initCartRegulator();
  }

  get cart() { return this._cart; }

  getProductData(id) {
    let data = this.productDataMap[id];
    if (!data) { data = this.productDataMap[id] = {}; }
    return data; 
  }

  init() {
    this._cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.initProductRegulators();
    this.initElementRegulators();
    subscribe(PUB_SUB_EVENTS.variantChange, (e)=>{ this.onVariantChange(e) });
    subscribe(PUB_SUB_EVENTS.cartUpdate, (e)=>{ this.onCartUpdate(e)});
    setTimeout(() => { this.initCookieRegulators(); }, 500);
  }

  initProductRegulators() {
    this._productInfos = document.querySelectorAll('product-info');
    this._productInfos.forEach((pi) => { this.setupProductInfo(pi); });
  }

  initElementRegulators() {
    try {
      const configElem = document.querySelector('#mbElementConfig');
      let config =  configElem ? JSON.parse(configElem.textContent.trim()) : [];
      if (!config.length) { return; }
      const sections = document.querySelectorAll('.shopify-section');
      this.elementConfig = {sections: {}, rules: config};
      sections.forEach((section) => {
        const sectionId = section.id;
        if (!sectionId) { return; }
        let key = sectionId.split("__").pop();
        this.elementConfig.sections[key] = section;
      });
    } catch (error) {
      console.error('Error initializing element regulator:', error);
    } 
  }

  initCookieRegulators() {
    let cmatch = document.cookie ? document.cookie.match(/(^|;\s)(cookies_accepted)\=(0|1)(;\s)?/) : null;
    if (!cmatch || cmatch[3] != "1") {
      const bar = _elementFromHTML(MB_COOKIE_BAR);
      document.body.insertBefore(bar, document.body.firstChild);
    }
  }

  setupProductInfo(pi) {
    const productId = pi.dataset.productId;
    const productData = this.getProductData(productId);
    if (!productId || pi.hasAttribute('regulated')) { return; }
    pi.setAttribute('regulated','');
    
    _shopifyFetch(pi.dataset.url,
      (url) => { url.searchParams.set('sections','mb-product-json'); }
    ).then((data) => {
      let json = _parseSectionsJSON(data);
      console.log('---------- _shopifyFetch:',json);
      const pj = json['mb-product-json'];
      const type = _dot(pj, 'product.type') || '';
      if (type == "byobSuite") { 
        pi.classList.add('byob-product');
        // Special handling for BYOB products
        document.addEventListener('cart:refresh', (e) => {
          setTimeout(() => { mbRefreshAndShowCartDrawer(); }, 10);
        }, true); // capture = true
        _mbRegulateBYOBProduct(pi, pj);
        _mbRegulateMediaAutoplay(pi);
        return; 
      } 
      else {
        productData.moneySample = pj.money_sample || "$1,234,567.89";
        productData.product = pj.product;
        productData.metafields = pj.metafields;
        productData.variant_metafields = pj.variant_metafields;
        productData.optionTree = _variantsOptionTree(_filterProductVariants(pi, productData));
        this.onProductDataLoaded(pi, productData);
      }
    });

    // Listen for changes to the product info
    pi.addEventListener('change', this.onProductInfoChange.bind(this));
  
    // Load the product data map
    const ldjs = pi.querySelector('script[type="application/ld+json"]');
    if (ldjs) {
      const jsonData = JSON.parse(ldjs.textContent);
      this.getProductData(productId).optionTree = _variantsOptionTree(jsonData.hasVariant);
    }
    // Manually trigger the first product info change
    setTimeout(() => { this.regulateProductInfo(pi); }, 10);
  }

  onProductDataLoaded(pi, productData) {
    const vs = pi.querySelector('variant-selects');
      const selectedOptions = _optionsForVariantSelects(vs);
      const optionTree = productData.optionTree || {};
    _mbRegulateProductImages(pi);
    _mbRegulateMediaAutoplay(pi);
    _mbRegulateVariantSelectsOptions(vs, selectedOptions, optionTree);
    _mbRegulateProductInfoLinks(pi, productData); 
    _mbRegulateVariantInfo(pi, productData);
    _mbRegulateElements(pi, this.elementConfig);
    _mbRegulateWidgets(pi, productData);
    _mbRegulateBundles(pi, productData);
    _mbRegulateInstallments(pi);
    _mbRegulateFormSubmit(pi, productData);
    _mbRegulateATCDisplay(pi, productData);
    _mbRegulateBuybar(pi, productData);
    _mbRegulateSections(pi, productData); 
  }

  onProductInfoChange(event) {
    const target = event.target;
    this.regulateProductInfo(target.closest('product-info')) ; 
  }

  onVariantChange(event) {
    const pi = document.querySelector(`#MainProduct-${event.data.sectionId}`);
    if (pi) {
      const productId = pi.dataset.productId;
      const productData = this.getProductData(productId);
      const vs = pi.querySelector('variant-selects');
      const selectedOptions = _optionsForVariantSelects(vs);
      const optionTree = productData.optionTree || {};
      _mbRegulateProductImages(pi);
      _mbRegulateMediaAutoplay(pi);
      _mbRegulateVariantSelectsOptions(vs, selectedOptions, optionTree);
      _mbRegulateProductInfoLinks(pi, productData);
      _mbRegulateVariantInfo(pi, productData);
      _mbRegulateElements(pi, this.elementConfig);
      _mbRegulateWidgets(pi, productData);
      _mbRegulateBundles(pi, productData);
      _mbRegulateInstallments(pi);
      _mbRegulateATCDisplay(pi, productData);
      _mbRegulateSections(pi, productData);
    }
  }

  onCartUpdate(event) {
    switch (event.source) {
      case "product-form": 
        this.onProductFormCartUpdate(event);
        break; 
      case "cart-items":
        this.onCartItemsCartUpdate(event);
        break; 
      case "product-bundle":
        this.onBundleCartUpdate(event);
        break;
    }
  }

  // FMW
  onProductFormCartUpdate(event) {
    console.log('product-form:cart-update', event);

    // Get the upsells that were added to the cart
    const items = _dot(event, 'cartData.items') || [];
    const itemsWithIncarts = []
    items.forEach((item) => {
      const bundleElem = document.querySelector(`mb-bundle[data-product-id="${item.product_id}"]`);
      if (bundleElem && bundleElem._info.incart_bundles > 0) { 
        itemsWithIncarts.push(item);
      }
    });
    
    if (itemsWithIncarts.length > 0) {
      const incarts = []; 
      const promises = itemsWithIncarts.map((item) => {
        return _shopifyFetch(item.url, (url) => { url.searchParams.set('sections', 'mb-product-json'); }
        ).then((data) => {
          let json = _parseSectionsJSON(data);
          let productData = json['mb-product-json'];; 
          const incartBundles = _dot(productData, ['metafields', 'incart_bundles']);
          if (!incartBundles || !incartBundles.length) { return null; }

          const vmetas = _dot(productData, ['variant_metafields', item.variant_id]);
          const exclusionMap = _atm(vmetas.bundle_exclusions, (vId) => vId, () => true);
          const incartMap = {};
          vmetas.bundle_variant_configs.forEach((vconf) => {
            const vconfs = incartMap[vconf.product_id] || [];
            vconfs.push(vconf);
            incartMap[vconf.product_id] = vconfs;
          });

          incartBundles.forEach((bundle) => {
            if (!bundle.product || !bundle.product.id) {
              return;
            }
            if (exclusionMap[bundle.product.id]) { return; }
            incarts.push({ info: bundle, vconfs: incartMap[bundle.product.id], gid: item.sku}); 
          }); 

          return {product: json['mb-product-json'], cartItem: item, gid: item.sku};
        });
      });
      Promise.all(promises).then((results) => {
        this._incartBundles = incarts;
        setTimeout(() => { _mbInjectIncartBundles(incarts);  }, 1000);
      });
    }
  }

  onCartItemsCartUpdate(event) {
    console.log('cart-items:cart-update', event);
    try {
      let items = _deepCopy(_dot(event,"cartData.items"));
      let updates = {}
      const ciElems = this.cart.querySelectorAll('.cart-item'); 
      // Handles nested gid dependencies
      for (let ctr = 0; ctr < 10; ctr++) {  
        let changed = false;
        const aggrs = _aggrItemSkus(items);
        items.forEach((item, i) => {
          const ciElem = ciElems[i];
          let max = _maxItemGidQantity(item, aggrs);
          if (max != item.quantity) {
            item.quantity = max;
            updates[item.key] = max;
            changed = true;
            ciElem.querySelector('.loading__spinner').classList.remove('hidden');
          }
        });
        if (!changed) { break; }
      }
      if (Object.keys(updates).length) { _mbUpdateCart(updates); }
    } catch (error) {
      console.error('Error on cart-items:cart-update', error);
    }
  }

  onBundleCartUpdate(event) {
    console.log('product-bundle:cart-update', event);
    try {
      if (this._incartBundles && !!this._incartBundles.length) {
        this._incartBundles = this._incartBundles.filter((bundle) => {
          return _dot(bundle,'info.product.id') != event.productId;
        });
        setTimeout(() => { _mbInjectIncartBundles(this._incartBundles); }, 1000);
      }
    } 
    catch (error) {
      console.error('product-bundle:cart-update', error);
    }
  }

  regulateProductInfo(pi) {
    if (!pi) { return; }
    const productId = pi.dataset.productId;
    const vs = pi.querySelector('variant-selects');
    const selectedOptions = _optionsForVariantSelects(vs);
    const productData = this.getProductData(productId);
    const optionTree = productData.optionTree || {};
    const validOptions = _findFirstValidOptions(selectedOptions, optionTree);
    if (!arePrimitiveArraysEqual(selectedOptions, validOptions)) { 
      _setVariantSelectsOptions(vs, validOptions);
    } 
    _mbRegulateVariantSelectsOptions(vs, validOptions, optionTree);
  }

  initCartRegulator() {
    if (!this.cart) { return; }
    setInterval(() => { 
      const checkoutButton = this.cart.querySelector('#CartDrawer-Checkout');
      if (checkoutButton.disabled && !this.cart.classList.contains('is-empty')) {
        checkoutButton.disabled = false;
        checkoutButton.classList.remove('disabled');
      }
    }, 1000);
  }

  static setup() {
    if (typeof window.regulator !== 'undefined') { return; }
    window.regulator = new Regulator();
    document.body.addEventListener('product-info:loaded',(e)=>{ 
      console.log('product-info:loaded');
      window.regulator.setupProductInfo(e.target); 
    })
    _observeVisibleVideo();
  }
}

/*
 * 1LSS - MAGBAK Popup
**/

const MB_POPUP_HTML = `
<mb-popup>
  <div class="background" aria-label="Close popup"></div>
  <div class="frame" aria-modal="true" tabindex="-1">
    <button type="button" class="close-popup" aria-label="Close popup">&#215;</button>
    <div class="content">${SP_SPINNER_HTML}</div>
    <div class="close_under">CLOSE</div>
  </div>
</mb-popup>`;

class MBPopup extends HTMLElement {

  constructor() {
    super();
    this.background = this.querySelector(".background");
    this.background.addEventListener('click',this.close.bind(this));
    this.closeButton = this.querySelector(".close-popup");
    this.closeButton.addEventListener('click', this.close.bind(this));
    this._content = this.querySelector(".content");
  }

  get content() { return this._content; }

  close() {
    let lps = document.querySelectorAll('mb-popup');
    if (lps.length == 1) { document.body.style.overflow = ''; }
    this.remove(); 
  }

  load(path) {
    if (!path) { return; }
    this.classList.add('loading');
    _fetcShopifyData(path).then((data) => {
      this.classList.remove('loading');
      this._content.innerHTML = '';
      let obj = Object.values(data)[0];
      if (obj.title) { _add(this._content, 'h2').innerHTML = obj.title; }
      if (obj.body_html) { _add(this._content, 'div',{cls:"rte"}).innerHTML = obj.body_html; }
    });
  }

  populate(html) {
    this._content.innerHTML = html;
    return this._content
  }

  static create() {
    const popup = _elementFromHTML(MB_POPUP_HTML);
    document.body.appendChild(popup);
    document.body.style.overflow = 'hidden';
    setTimeout(() => { popup.classList.add('visible'); }, 10);
    return popup;
  }
}

customElements.define('mb-popup', MBPopup);


/*
 * 1LSS - MAGBAK Slider
**/

const MB_SLIDER_HTML = `
<mb-slider class="mb-slider">
  <div class="mb-slider-rail"></div>
</mb-slider>`;

class MBSlider extends HTMLElement {
  constructor() {
    super();
    this.vertical = this.getAttribute("direction") == "vertical";
    this.rail = this.querySelector(".mb-slider-rail");
    this.rail.addEventListener("scroll",this.onScroll.bind(this));
    this.slides = this.querySelectorAll(".mb-slider-slide");
    this._firstSlide = this.slides[0];
    this._index = 0;
  }
  refresh() {
    this.slides = this.querySelectorAll(".mb-slider-slide");
    this._firstSlide = this.slides[0];
    this._index = this._index < this.slides.length ? this._index : 0;
    this.dataset.slides = this.slides.length;
  }
  onScroll(evt) {
    if (!this._firstSlide) return;
    let newIndex;
    if (this.vertical) {
      newIndex = Math.round(this.rail.scrollTop / this._firstSlide.clientHeight);
    } else {
      newIndex = Math.round(this.rail.scrollLeft / this._firstSlide.clientWidth);
    }
    if (newIndex !== this._index) {
      this._index = newIndex;
      this.onSlideChange()
    }
  }
  onSlideChange() {
    this.dispatchEvent( new CustomEvent("indexchange", { bubbles: true, detail: { index: this._index } }));
  }
  scrollToIndex(index, behavior) {
    this.scrollToSlide(this.slides[index], behavior);
  }
  scrollToSlide(slide, behavior="smooth") {
    if (!slide) return;
    let rail = this.rail;
    if (this.vertical) {
      let offset = slide?.offsetTop - this.slides[0]?.offsetTop;
      rail.scrollTo({
        top: offset - (rail.clientHeight/2) + (slide.clientHeight/2),
        behavior: behavior
      });
    } else {
      let offset = slide?.offsetLeft - this.slides[0]?.offsetLeft;
      rail.scrollTo({
        left: offset - (rail.clientWidth/2) + (slide.clientWidth/2),
        behavior: behavior
      });
    }
  }
}
customElements.define('mb-slider', MBSlider);

/*
 * 1LSS - MAGBAK Media Slider
**/

const MB_MEDIA_SLIDER_HTML = `
<mb-media-slider class="mb-slider">
  <div class="mb-slider-rail"></div>
</mb-media-slider>`;

class MBMediaSlider extends MBSlider {
  constructor() {
    super();
    this.forEeachVideo((vid,i)=>{
      vid.addEventListener('ended', () => {
        this.scrollToIndex((i+1) % this.slides.length);
      });
    });
  }
  forEeachVideo(f) {
    if(!f) return;
    this.slides.forEach((slide, i) => {
      let vid = slide.querySelector('video');
      if (!vid) return;
      f(vid,i);
    });
  }
  onSlideChange() {
    super.onSlideChange();
    this.slides.forEach((slide, i) => {
      let vid = slide.querySelector('video');
      if (!vid) { return; }
      if (i == this._index) {
        vid.play();
        vid.muted = false;
      } else {
        vid.pause();
        vid.currentTime = 0;
      }
    });
  }
  currentVideo() {
    let slide = this.slides[this._index];
    if (!slide) { return; }
    return slide.querySelector('video');
  }
  play() {
    let vid = this.currentVideo();
    if (!vid) { return; }
    vid.play();
  }
  stop() {
    let vid = this.currentVideo();
    if (!vid) { return; }
    vid.pause();
    vid.currentTime = 0;
  }
  playAtIndex(index) {
    this._index = index;
    this.scrollToIndex(index,"instant");
    this.play();
  }
}
customElements.define('mb-media-slider', MBMediaSlider);

/* 
 * 1LSS - MAGBAK Bundle Element
**/

const MB_BUNDLE_HTML = `
<mb-bundle class="mb-bundle">
  <div class="mb-bundle-image"></div>
  <div class="mb-bundle-title"></div>
  <div class="mb-bundle-cost">
    <span class="price-compare"></span>
    <span class="price-regular"></span>
  </div>
  <div class="mb-bundle-action">
    <div class="toggle" tabindex="0"></div>
  </div>
  <div class="mb-bundle-options"></div>
  <div class="mb-bundle-properties"></div>
</mb-bundle>`;

class MBBundle extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector(".mb-bundle-image");
    this._title = this.querySelector(".mb-bundle-title");
    this.cost = this.querySelector(".mb-bundle-cost");
    this.action = this.querySelector(".mb-bundle-action");
    this.options = this.querySelector(".mb-bundle-options");
    this.properties = this.querySelector(".mb-bundle-properties");
    this.action.addEventListener('click', this.onActionClick.bind(this));
    this.image.addEventListener('click', this.onInfoClick.bind(this));
    this._title.addEventListener('click', this.onInfoClick.bind(this));
  }

  set media(media) { if (media) { this.image.innerHTML = `<img src="${media.src}" alt="${media.alt}">`}; }
  set title(txt) { this._title.innerHTML = txt; }
  get product() { return this._info.product; }
  get info() { return this._info; }
  get vconfs() { return this._vconfs; }
  get title() { return this._title.innerHTML; }

  set enabled(val) {
    if (this.dataset.enabled == val.toString()) { return; }
    this.dataset.enabled = val;
    this.dispatchEvent(new Event('change',{ bubbles: true }));
  }

  enable() { this.enabled = "true"; }
  disable() { this.enabled = "false"; }
  isEnabled() { return this.dataset.enabled == "true"; }
  isExcluded() { return this.dataset.excluded == "true"; }
  isComplementary() { return this.dataset.complementary == "true"; }
  isPurchasable() { return this.isEnabled() && !this.isExcluded() && !this.isComplementary(); }
  
  toggleEnable() { 
    this.enabled = this.isEnabled() ? "false" : "true";
  }

  onActionClick(evt) { 
    this.toggleEnable();
  }

  onInfoClick(evt) {
    const popup = MBPopup.create();
    const productSummary = _elementFromHTML(MB_PRODUCT_SUMMARY_HTML)
    popup.content.innerHTML = '';
    popup.content.appendChild(productSummary);
    const variant = this.selectedVariant();
    productSummary.populateProduct(this.product, variant);
    if (variant && variant.sku ) { 
      _filterImageElements(productSummary.querySelectorAll('img'), variant.sku, variant.id.toString(), (img, pass)=>{ 
        const slide = img.closest('.mb-slider-slide'); 
        if (!pass && slide) { slide.remove(); }
      });
      productSummary.refresh();
    }
    const vmetas = _dot(this.info.variant_metafields, variant.id);
    if (vmetas && vmetas.description) {
      productSummary.description = vmetas.description;
    }

    let img = this.image.querySelector('img'); 
    if (img && img.src) {
      productSummary._viewer.selectWithUrl(img.src);
    } else {
      productSummary._viewer.selectMedia(); 
    }
  }

  populate(info) {
    this._info = info;
    this.media = this.product.media[0];
    this._title.innerHTML = info.tagline || this.product.title;
    this.setAttribute('product-available', this.product.available);
    this.dataset.productId = this.product.id;
    this._variantPicker = _add(this.options,'mb-variant-picker'); 
    this._variantPicker.build(this.product, info.variant_metafields, info.swatches); 
    this._variantPicker.addEventListener('change', () => { 
      this.enable();
      const selectedVariant = this._variantPicker.selectedVariant;
      this.presentVariantWithId( selectedVariant?.id);
    }); 
    this.presentVariantWithId(this._variantPicker.selectedVariant?.id);

    // Check to see if an input or select was clicked on the variant picker to enable the bundle
    this._variantPicker.addEventListener('click', (evt) => {
      const target = evt.target
      const tagName = target.tagName.toLowerCase();
      if ( tagName == 'select' ) {
        this.enable();
      } else if ( tagName == 'input' && target.type == 'radio') {
        if (!this.isEnabled()) { 
          this.enable();
        } else if (target.checked) {
          this.disable();
        }
      } 
    });

    // Check for note 
    if (info.note) {
      let parts = info.note.split(":"); 
      this._note = _add(this.options, 'div', {cls: 'mb-bundle-note'});
      if (parts.length > 1 && parts[0].match(/\/\w+/)) {
        let pathname = parts.shift();
        this._note.addEventListener('click',(e)=> {
          e.stopPropagation();
          e.preventDefault(); 
          const popup = MBPopup.create();
          popup.load(pathname.trim());
        });
      } 
      this._note.innerHTML = parts.join(":");
    }

  }

  selectedVariant() {
    const variantPicker = this.options.querySelector('mb-variant-picker');
    return variantPicker ? variantPicker.selectedVariant : null;
  }

  selectedVariants() {
    const selectedVariant = this.selectedVariant();
    return selectedVariant ? [selectedVariant] : [];
  }

  presentVariantWithId(id) {
    const variants = _dot(this.product,["variants"]);
    let variant = id ? variants.find(v => v.id == id) : null; 
    if (!variant) { return; }
    const vmetas = _dot(this.info.variant_metafields, variant.id);

    this.media = variant.featured_image;
    this.setCost(variant.price, variant.compare_at_price); 

    this.setAttribute('available', variant.available);
    if (this._parentSku && variant.sku) { 
      let matchedMedia = _mbFilterMedia(this.product.media, variant.sku);
      matchedMedia = _mbFilterMedia(matchedMedia, this._parentSku); 
      matchedMedia = matchedMedia.filter((m) => m.media_type != 'video');
      if (matchedMedia && matchedMedia.length > 0) { this.media = matchedMedia[0]; }
    }

    const props = vmetas && vmetas.cart_properties;
    const propElems = this.properties.querySelectorAll('input');
    if (props && props.length) {
      this.dataset.properties = true;
      const propElemMap = _atm(propElems, (pe)=>pe.getAttribute('key'), (pe)=>{
        pe.dataset.enabled = false;
        return pe; 
      });
      props.forEach((prop) => {
        let propElem = propElemMap[prop.key];
        if (!propElem) { 
          propElem = _add(this.properties, 'input', {...prop.attributes, cls: prop.css_classes, key:prop.key});
          propElem.addEventListener('input',()=>{ 
            this.dataset.enabled = propElem.value.length > 0; 
          });
        }
        propElem.dataset.enabled = true;
      }); 
    } 
    else {
      delete this.dataset.properties;
    }
    let vcount = this._variantPicker.vcount;
    if (this._note) { vcount++; }
    this.setAttribute('vcount', vcount);
  }

  setCost(price, compare) {
    price = price || 0;
    let cm = this.querySelector(".price-compare");
    let pm = this.querySelector(".price-regular");    
    
    delete pm.dataset.savings; 
    let note;
    this.classList.remove('discounted');
    const discountAmount = this.info.discount_amount || 0;
    if (discountAmount > 0) {
      compare = price; 
      if (this.info.discount_type == 'Percent') {
        let percent = Math.min(discountAmount, 100);
        price = price * (1 - (percent / 100));
        note = percent + '% OFF';
      } 
      else {
        let discount = Math.min(discountAmount, price);
        price = price - discount;
        note = mbFormatPrice(discount, this._moneySample).replace(/.00$/,"") + ' OFF';
      }
    } 
    else if (compare > price) {
      let percent = Math.floor(((compare - price) / compare) * 100);
      note = percent + '% OFF';
    }
    
    if (cm && compare && compare > price) {
      cm.innerHTML = mbFormatPrice(compare, this._moneySample);
      this.classList.add('discounted');
      pm.dataset.savings = note;
    }
    pm.innerHTML = mbFormatPrice(price, this._moneySample);
    this.dataset.price = price;
  }

  filter(vconfs) {
    vconfs = vconfs || [];
    const vcmap = {}; 
    vconfs.forEach((vc) => { vc.variants.forEach((v) => vcmap[v.id] = vc); }); 
    const variants = vconfs.length > 0 ? this.product.variants.filter((v) => vcmap[v.id] != undefined) : this.product.variants;
    this._variantPicker.filter(variants, this.info.variant_metafields);
    const selectedVariant = this._variantPicker.selectedVariant;
    this.presentVariantWithId(selectedVariant?.id);
    let svc = selectedVariant ? vcmap[selectedVariant.id] : null;
    this.dataset.complementary = svc ? svc.included : false;
  }

  eachProperty(cbk) {
    if (!this.dataset.properties || !cbk) { return; }
    const propElems = this.properties.querySelectorAll('input');
    for (let i = 0; i < propElems.length; i++) {
      let pe = propElems[i];
      if (pe.dataset.enabled) {
        let val = pe.value; 
        if (val && pe.classList.contains('uppercase')) { val = val.toUpperCase(); }
        if (cbk(pe.getAttribute('key'), val, pe) === false) { break; }
      }
    }
  }

}
customElements.define('mb-bundle', MBBundle);



/* 
 * 1LSS - MAGBAK Cart Bundle Element
**/

const MB_CART_BUNDLE_HTML = `
<mb-cart-bundle class="mb-bundle">
  <div class="mb-bundle-image"></div>
  <div class="mb-bundle-title"></div>
  <div class="mb-bundle-cost">
    <span class="price-compare"></span>
    <span class="price-regular"></span>
  </div>
  <div class="mb-bundle-action">
    <button class="atc" tabindex="0">Add</button>
  </div>
  <fieldset class="mb-bundle-options">
    <legend class="form__label"></legend>
  </fieldset>
  <div class="mb-bundle-properties"></div>
</mb-cart-bundle>`;

class MBCartBundle extends MBBundle {
  constructor() {
    super();
    this._atc = this.querySelector('.atc');
  }
  onActionClick(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    const selectedVariant = this.selectedVariant();
    if (!selectedVariant) { return; }

    let abort = false;
    const items = []; 
    const variants = this.selectedVariants();
    variants.forEach((variant) => {
      if (!variant.available) { return; }
      const item = { id: variant.id, quantity: 1, properties: { _gid: this.dataset.gid } };
      this.eachProperty((key, value, pe) => {
        item.properties[key] = value;
        if (pe.getAttribute("required") && !pe.reportValidity()) {
          abort = true;
          return false;
        }
      });
      items.push(item);
    });

    if (abort) { return; }

    this._atc.disabled = true;
    this._atc.classList.add('loading');
    this._atc.appendChild(_elementFromHTML(SP_SPINNER_HTML));
    _mbAddToCart(items,(cartData)=>{
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-bundle',
        productVariantId: selectedVariant.id,
        cartData: cartData,
        productId: this.dataset.productId,
      });
    });
  }
}

customElements.define('mb-cart-bundle', MBCartBundle);

/*
 * 1LSS - MAGBAK Variant Picker
**/
class MBVariantPicker extends HTMLElement {
  constructor() {
    super();
  }

  get product() { return this._product; }
  get selectedVariant() { return _dot(this._optionTree, this._selectedOptions); }

  build(product, variantMetafields, swatches) {
    if (!product || !product.variants || product.variants.length == 0) { return; }
    
    this._swatches = swatches;
    this._product = product;
    
    const variants = _sortAndFilterVariants(product.variants, variantMetafields);
    const fav = variants[0]; // First available variant as favorite
    this._optionsByLevel = [];
    variants.forEach(variant => {
      variant.options.forEach((option, level) => {
        const values = _reg(this._optionsByLevel, level, []);
        if (!values.includes(option)) { values.push(option); }
      });
    });
    this._optionTree = _buildOptionTree(variants);
    this._selectedOptions = fav ? fav.options.slice() : [];

    // Build the option selectors
    this._product.options.forEach((optionName, level) => {
      const values = this._optionsByLevel[level] || [];
      const onmatch = optionName.match(/\(([^)]+)\)$/);
      const optionSurname = onmatch ? onmatch[1] : optionName;
      let useSwatches = _optionsHasSwatch(optionSurname, values, this._swatches);
      if (useSwatches) {
        const fieldset = _add(this, 'fieldset', { class: "mb-variant-option-swatch", 'data-option-name': optionName });
        const legend = _add(fieldset, 'legend', { class: "form__label" });
        legend.innerHTML = optionSurname;
        values.forEach((optionValue) => {
          const id = `variant-picker-${product.id}-${level}-${optionValue}`;
          const swatchSteps = [optionSurname, optionValue];
          let swatch = _dot(this._swatches, swatchSteps);
          if (!swatch || (!swatch.color && !swatch.image)) { swatch = _dot(DEFAULT_SWATCHES, swatchSteps); }
          const input = _add(fieldset, 'input', { type: "radio", name: `variant-picker-${product.id}-${level}`, value: optionValue, id: id});
          const label = _add(fieldset, 'label', { for: id});
          if (_configSwatchElement(label, swatch)) {
            input.classList.add('swatch');
          }
          else {
            label.innerHTML = optionValue;
            input.classList.add('bubble');
          }
        });
      } else {
        const select = _add(this, 'select', { class: "mb-variant-option-select", 'data-option-name': optionName });
        values.forEach((optionValue) => {
          const option = _add(select, 'option', { value: optionValue });
          option.innerHTML = optionValue;
        });
      }
    });
    this.updateSelectedOptions(this._selectedOptions);
    this.updateOptionsVisibility();
    this.addEventListener('change', this.onChange.bind(this));
  }

  getSelectedOptions() {
    const selectedOptions = [];
    const optionElements = this.querySelectorAll('input[type="radio"]:checked, select');
    optionElements.forEach((elem, level) => {
      const optionValue = elem.value;
      selectedOptions[level] = optionValue;
    });
    return selectedOptions;
  }

  updateSelectedOptions(newOptions) {
    this._selectedOptions = newOptions;
    const optionElements = this.querySelectorAll('fieldset, select');
    optionElements.forEach((elem, level) => {
      const optionValue = newOptions[level];
      if (elem.tagName.toLowerCase() == 'fieldset') {
        const inputs = elem.querySelectorAll('input[type="radio"]');
        inputs.forEach((input) => {
          if (input.value == optionValue) {
            input.checked = true;
          }
        });
      } else {
        elem.value = optionValue;
      }
    }); 
  }

  updateOptionsVisibility() {
    const selectedOptions = this.getSelectedOptions();
    const optionElements = this.querySelectorAll('fieldset, select');
    let branch = this._optionTree;
    this.vcount = 1; 
    for (let level = 0; level < optionElements.length; level++) {
      const elem = optionElements[level];
      const selectedOption = selectedOptions[level];
      let octr = 0;
      if (elem.tagName.toLowerCase() == 'fieldset') {
        const lengend = elem.querySelector('legend');
        if (lengend) { lengend.dataset.value = selectedOption; }
        const inputs = elem.querySelectorAll('input[type="radio"]');
        inputs.forEach((input) => {
          const bud = branch[input.value]; 
          if (bud !== undefined) {
            input.classList.remove('aberration');
            octr++;
          } else {
            input.classList.add('aberration');
          }
          if (bud?.id) { input.setAttribute('available', bud.available); }
        });
      } 
      else {
        const options = elem.querySelectorAll('option');
        options.forEach((option) => {
          const bud = branch[option.value]; 
          if (bud !== undefined) {
            option.removeAttribute('disabled');
            octr++;
          } else {
             option.setAttribute('disabled', '');
          }
          if (bud?.id) { option.setAttribute('available', bud.available); }
        });
      }
      elem.dataset.optionCount = octr;
      branch = branch[selectedOption];
      this.vcount *= octr;
    };
  } 

  onChange(evt) {
    let newSelectedOptions = this.getSelectedOptions();
    this.updateSelectedOptions(_nearestValidOptions(newSelectedOptions, this._optionTree));
    this.updateOptionsVisibility();
  }

  filter(variants, variantMetafields) {
    variants = !variants?.length ? this.product.variants : variants;
    variants = _sortAndFilterVariants(variants, variantMetafields);
    this._optionTree = _buildOptionTree(variants);
    this.updateSelectedOptions(_nearestValidOptions(this.getSelectedOptions(), this._optionTree));
    this.updateOptionsVisibility();
  }

}
customElements.define('mb-variant-picker', MBVariantPicker);

function _buildOptionTree(variants) {
  const tree = {};
  if (!variants) { return tree; }
  variants.forEach(variant => {
    let options = variant.options;
    let branch = tree;
    for (let i = 0; i < options.length; i++) {
      let option = options[i];
      if (i === options.length - 1) {
        branch[option] = variant
      } else {
        if (!branch[option]) { branch[option] = {}; }
        branch = branch[option];
      }
    }
  });
  return tree;
}

// Returns the variants sorted with available first and filtered to remove hidden ones
function _sortAndFilterVariants(variants, variantMetafields) {
  if (!Array.isArray(variants)) { return [];}
  const cleaned = [];
  variants.forEach(v => { // Add available variants first
    const metas = _dot(variantMetafields, `${v.id}`) || {};
    if (v && v.available && !metas.force_hide) cleaned.push(v);
  });
  variants.forEach(v => { // Add unavailable variants at the end
    const metas = _dot(variantMetafields, `${v.id}`) || {};
    if (v && !v.available && !metas.force_hide) cleaned.push(v);
  }); 
  return cleaned;
}

function _optionsHasSwatch(optionName, optionValues, swatches) {
  if (!swatches) { return false; }
  for (let i = 0; i < optionValues.length; i++) {
    const ov = optionValues[i];
    let swatch = _dot(swatches, [optionName, ov]);
    if (!swatch || (!swatch.color && !swatch.image)) { 
      swatch = _dot(DEFAULT_SWATCHES, [optionName, ov]); 
    }
    if (swatch && (swatch.color || swatch.image)) {
      return true;
    }
  }
  return false;
}

function _nearestValidOptions(options, optionTree) {
  let branch = optionTree;
  for (let i = 0; i < options.length; i++) {
    const option = options[i];
    if (branch[option]) {
      branch = branch[option];
    } else {
      const keys = Object.keys(branch);
      if (keys.length > 0) {
        options[i] = keys[0];
        branch = branch[keys[0]];
      } else {
        break;
      }
    }
  }
  return options;
}

/*
 * 1LSS - MAGBAK Media Viewer
**/

const MB_MEDIA_VIEWER_HTML = `
<mb-media-viewer>
  ${MB_MEDIA_SLIDER_HTML}
  ${MB_SLIDER_HTML}
</mb-media-viewer>`;

class MBMediaViewer extends HTMLElement {
  constructor() {
    super();
    this._screen = this.querySelector("mb-media-slider");
    this._selector = this.querySelector("mb-slider");
    this._screen.addEventListener('indexchange', this.onScreenChange.bind(this));
  }

  refresh() {
    this._screen.refresh();
    this._selector.refresh();
  }

  selectMedia(index = 0) {
    const slide = this._selector.slides[index];
    if (slide) { slide.click(); }
  }

  selectWithUrl(mediaUrl) {
    const slide = Array.from(this._selector.slides).find((s) => {
      const img = s.querySelector('img');
      return img && img.src.endsWith(mediaUrl);
    });
    if (slide) { 
      this._selector.scrollToSlide(slide, "instant");
      setTimeout(() => { slide.click(); }, 10);
    }
  }

  onScreenChange(evt) {
    const index = evt.detail.index; 
    const selectorSlide = this._selector.slides[index];
    this._selector.scrollToIndex(index);
    const selectedSlide = this._selector.querySelector('.selected');
    if (selectedSlide) { selectedSlide.classList.remove('selected'); }
    selectorSlide.classList.add('selected');
  }

  populateMedia(media) {
    media.forEach((m) => {
      let screenSlide; 
      switch (m.media_type) {
        case "video": 
          screenSlide= this.addVideo(m);
          break; 
        case "image": 
          screenSlide = this.addImage(m);
          break; 
      }; 
      const selectorSlide = _add(this._selector.rail, 'div', { class: "mb-slider-slide" });
      _add(selectorSlide, 'img', { src: m.preview_image.src, alt: m.alt });
      selectorSlide.addEventListener('click',()=>{ 
        const selectedSlide = this._selector.querySelector('.selected');
        if (selectedSlide) { selectedSlide.classList.remove('selected'); }
        selectorSlide.classList.add('selected');
        this._screen.scrollToSlide(screenSlide,"instant"); 
      });
    }); 
    this.refresh(); 
  }

  addVideo(media) {
    const screenSlide = _add(this._screen.rail, 'div', { class: "mb-slider-slide" });
    const video = _add(screenSlide, 'video', { 
      playsinline:"playsinline", 
      autoplay:"autoplay", 
      loop:"loop", 
      preload:"auto",
      muted:"muted", 
      poster: media.preview_image 
    });
    media.sources.forEach((source) => { 
      _add(video, "source", { src: source.url, type: source.mime_type });
    }); 
    _add(video, "img", { src: media.preview_image.src, alt: media.alt });
    return screenSlide
  }

  addImage(media) {
    const screenSlide = _add(this._screen.rail, 'div', { class: "mb-slider-slide" });
    _add(screenSlide, 'img', { src: media.src, alt: media.alt });
    return screenSlide; 
  }
}

customElements.define('mb-media-viewer', MBMediaViewer);


/*
 * 1LSS - MAGBAK Product Summary 
**/

const MB_PRODUCT_SUMMARY_HTML = `
<mb-product-summary>
  <h2 class="mb-product-summary-title"></h2>
  ${MB_MEDIA_VIEWER_HTML}
  <div class="mb-product-summary-description rte"></div>
</mb-product-summary>`;

class MBProductSummary extends HTMLElement {
  constructor() {
    super();
    this._title = this.querySelector(".mb-product-summary-title");
    this._viewer = this.querySelector("mb-media-viewer");
    this._description = this.querySelector(".mb-product-summary-description");
  }

  set description(txt) { this._description.innerHTML = txt; }

  populateProduct(product, variant) {
    this._title.innerHTML = product.title;
    this._viewer.populateMedia(product.media);
    this._description.innerHTML = product.description;
    if (variant && product.variants.length > 1) {
      this._title.dataset.variant = variant.options.join(' | ');
    } else {
      delete this._title.dataset.variant;
    }
  }

  refresh() {
    this._viewer.refresh();
  }
}

customElements.define('mb-product-summary', MBProductSummary);


/*
 * 1LSS - MAGBAK Product Summary 
**/

const MB_BUYBAR = `
<mb-buybar>
  <div class="mb-buybar-image"></div>
  <div class="mb-buybar-title"></div>
  <div class="mb-buybar-cost">
    <span class="price-compare"></span>
    <span class="price-regular"></span>
  </div>
  <div class="mb-buybar-options"></div>
  <div class="mb-buybar-action">
    <button class="atc button" tabindex="0">
      <span>Add to cart</span>
      <div class="loading__spinner hidden">
        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>
      </div>
    </button>
  </div>
</mb-buybar>`;


class MBBuybar extends HTMLElement {
  constructor() {
    super();
    this._image = this.querySelector(".mb-buybar-image");
    this._title = this.querySelector(".mb-buybar-title");
    this._title.addEventListener('click', this.onOptionsClick.bind(this));
    this._options = this.querySelector(".mb-buybar-options");
    this._options.addEventListener('click', this.onOptionsClick.bind(this));
    this._button = this.querySelector(".mb-buybar-action button");
    this._button.addEventListener('click', this.onButtonClick.bind(this));
  }

  set media(media) { if (media) { this._image.innerHTML = `<img src="${media.src}" alt="${media.alt}">`}; }
  set title(txt) { this._title.innerHTML = txt; }
  set options(txt) { this._options.innerHTML = txt; }

  onOptionsClick(evt) {
    if (!this._pi) { return; }
    // this._pi.scrollIntoView({ behavior: 'smooth', block: 'center' });
    let elem = this._pi;
    let selects = elem.querySelector('variant-selects');
    if (selects) { elem = selects; }
    const y = elem.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }

  onButtonClick(evt) {
    if (!this.buyButton) { return; }
    this.buyButton.click();
    this._button.classList.add('loading');
    this._button.querySelector('.loading__spinner').classList.remove('hidden');
    setTimeout(() => {
      this._button.classList.remove('loading');
      this._button.querySelector('.loading__spinner').classList.add('hidden');
    }, 2000);
  }

  attach(pi, productData) {
    this._pi = pi;
    this._moneySample = productData.moneySample;
    const product = productData.product;
    this.title = product.title;
    this.buyButton = pi.querySelector(`#ProductSubmitButton-${pi.dataset.section}`);

    const refreshBuybar = ()=>{
      const bundles = pi.querySelectorAll('mb-bundle') || [];
      const selectedVariant = _getSelectedVariant(pi, productData);
      if (!selectedVariant) { return; }

      this.options = selectedVariant.options.length > 0 ? selectedVariant.options.join(' | ') : "";
      this.media = selectedVariant.featured_image || product.media[0];
      this.dataset.variants = product.variants.length;

      const items = [selectedVariant]; 
      bundles.forEach((bundle) => {
        if (!bundle.isPurchasable()) { return; }
        const variant = bundle.selectedVariant();
        if (!variant.available) { return; }
        items.push({price:parseInt(bundle.dataset.price) || 0});
      });
      let total = 0;
      let count = -1;
      items.forEach((item) => { total += parseInt(item.price) || 0; count++; });
      this.setCost(total, 0);

      const bbCost = this.querySelector(".mb-buybar-cost");
      if (count > 0) {
        bbCost.dataset.addons = count;
      } else {
        delete bbCost.dataset.addons;
      }

      let atcSpan = this._button.querySelector('span');
      if (this.buyButton && !selectedVariant.available) {
        this._button.disabled = true;
        atcSpan.innerHTML = 'Sold out';
      } else {
        this._button.removeAttribute('disabled');
        atcSpan.innerHTML = 'Add to cart';
      }
    };

    pi.addEventListener('change', (e) => {
      refreshBuybar(); 
    }); 

    refreshBuybar(); 
  }

  setCost(price, compare) {
    price = price || 0;
    let cm = this.querySelector(".price-compare");
    if (cm) {
      if (compare && compare > price) {
        cm.innerHTML = mbFormatPrice(compare, this._moneySample);
        this.classList.add('discounted');
      }
      else {
        this.classList.remove('discounted');
      }
    }
    let pm = this.querySelector(".price-regular");
    pm.innerHTML = mbFormatPrice(price, this._moneySample);
  }

  static register() {
    let buybar = document.querySelector('mb-buybar');
    if (buybar) { return buybar; }
    buybar = _elementFromHTML(MB_BUYBAR);
    document.body.appendChild(buybar);
    return buybar;
  }

}
customElements.define('mb-buybar', MBBuybar);


/*
 * 1LSS - MAGBAK Cookie Consent
**/

const MB_COOKIE_BAR = `
<mb-cookie-bar>
  <div class="mb-cookie-bar-note">
    <p class="cookie-base-bar-details__title h5">We use cookies to provide a better user experience. By continuing to use our site you agree with our privacy terms. <a href="/policies/privacy-policy">Learn more<span class="visually-hidden"> about our privacy policy</span>.</a></p>
  </div>
  <div class="mb-cookie-bar-action">
    <button name="accept" class="button mb-cookie-bar-accept">
      Accept <span class="visually-hidden"> all website cookies</span>
    </button>
  </div>
</mb-cookie-bar>`;

const COOKIE_ACCEPT_SCROLL = 1000;

class MBCookieBar extends HTMLElement {
  constructor() {
    super();
    this._accept = this.querySelector(".mb-cookie-bar-accept");
    this._accept.addEventListener('click', this.onAcceptClick.bind(this));
    this.observeInverval = setInterval(()=>{ this.observeScroll();}, 1000);
  }

  onAcceptClick(evt) {
    evt.preventDefault();
    this.acceptCookies();
  }

  observeScroll() {
    let bcr = document.body.getBoundingClientRect();
    if (bcr && Math.abs(bcr.y) > COOKIE_ACCEPT_SCROLL) {
      this.acceptCookies();
    }
  }

  acceptCookies() {
    if (this.classList.contains('accepted')) { return; }
    this.classList.add('accepted');
    this._accept.disabled = true;
    this._accept.innerHTML = 'Thanks';
    document.cookie = "cookies_accepted=1";
    this.setAttribute("aria-hidden", true);
    if (this.observeInverval) {
      clearInterval(this.observeInverval);
      this.observeInverval = null;
    }
  }

}
customElements.define('mb-cookie-bar', MBCookieBar);


class MBComparo extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // listen for window resize to adjust layout if needed
    window.addEventListener('resize', () => {
      this.adjustLayout();
    });
    this.adjustLayout();
  }
  
  adjustLayout() {  
    // Get the comparo features 
    const features = this.querySelector('.mb-comparo-features');
    const items = this.querySelectorAll('.mb-comparo-item');

    // Travers the h4 elements, find the max height and set all to that height
    const h4Elements = this.querySelectorAll('h4');
    let maxH4Height = 0;
    h4Elements.forEach((h4) => {
      const h4Height = h4.offsetHeight;
      if (h4Height > maxH4Height) {
        maxH4Height = h4Height;
      }
    });
    h4Elements.forEach((h4) => {
      h4.style.height = maxH4Height + 'px';
    });

    // Traverse the list under the features and set the height of each item accordingly
    const featureListItems = features.querySelectorAll('ul li');
    featureListItems.forEach((featureItem, index) => {
      const featureHeight = featureItem.offsetHeight;
      items.forEach((item) => {
        const itemListItems = item.querySelectorAll('ul li');
        if (itemListItems[index]) {
          itemListItems[index].style.height = featureHeight + 'px';
        }
      });
    });
  }

}

customElements.define('mb-comparo', MBComparo);


/*
 * 1LSS - MAGBAK Helper Methods
**/

function _filterImageElements(images, sku, vId, onFilter) {
  const filtered = [];
  images.forEach((img) => {
    if (img.dataset.filter) { return; }
    const alt = img.getAttribute('alt');
    if (!alt) { return; }
    let parts = alt.split(RGX_PIPE_DELIM);
    if (parts.length > 1) {
      let filter = parts.pop().trim();
      img.dataset.filter = filter;
      img.alt = parts.join(' | ');
    }
  });
  images.forEach((img) => {
    const filter = img.dataset.filter;
    let pass = true; 
    if (filter) {
      const parts = filter.split(RGX_COMMA_DELIM);
      const negs = parts.filter((p) => p.startsWith('!'));
      if (negs.length > 0) {
        const nset = new Set(negs);
        pass = !nset.has(`!${sku}`);
      } else {
        const pset = new Set(parts);
        pass = (pset.has(sku) || pset.has(vId));
      }
    }
    if (onFilter) { onFilter(img, pass); }
    if (pass) { filtered.push(img);} 
  });
  return filtered
}

function _mbRegulateProductImages(pi) {
  const selectedVariant =_getSelectedVariant(pi);
  if (!selectedVariant) { return; }
  const images = pi.querySelectorAll('media-gallery img');
  _filterImageElements(images, selectedVariant.sku, selectedVariant.id.toString(), (img, pass)=>{
    const li = img.closest('li')
    if (pass || _dot(selectedVariant,"featured_media.id") == img.dataset.mediaId) {
      li.classList.remove('hidden');
    } else {
      li.classList.add('hidden');
    }
  });
  pi.querySelectorAll("media-gallery slider-component").forEach((slider) => {
    slider.resetPages();
  });
}

function _mbRegulateMediaAutoplay(pi) {
  const gallery = pi.querySelector(`#MediaGallery-${pi.dataset.section}`);
  const viewer = pi.querySelector(`#GalleryViewer-${pi.dataset.section}`);
  const thumbs = pi.querySelector(`#GalleryThumbnails-${pi.dataset.section}`);
  if (!gallery || gallery.hasAttribute('observing')) { return; }
  gallery.setAttribute('observing','');
  viewer.addEventListener('slideChanged', debounce((evt)=>{
    console.log('slideChanged',evt.detail);
    window.pauseAllMedia();
    const slide = evt.detail.currentElement; 
    const dm = slide.querySelector('deferred-media');
    if (!dm) { return }
    if (dm.hasAttribute('loaded')) {
      const video = dm.querySelector('video');
      if (!video) { return; }
      if (!isVideoPlaying(video)) { 
        video.play(); 
      }
    }
    else {
      dm.loadContent();
      const video = dm.querySelector('video');
      video.addEventListener("canplay", (event) => {
        slide.classList.add('is-active');
      });
    }
  }, 500));
}

function _mbRegulateProductInfoLinks(pi, productData) {
  const fieldsets = pi.querySelectorAll('fieldset'); 
  fieldsets.forEach((fieldset, i) => {
    let infolink = _parseLinkConfig(_dot(productData.metafields,`config.options_${i+1}_info`));
    if (infolink) { 
      let legend = fieldset.querySelector('legend');
      if(!legend.hasAttribute('questionable')) {
        legend.setAttribute('questionable',true);
        legend.setAttribute('data-label',infolink.label);
        legend.addEventListener('click',_loadMBPopup);
        legend.dataset.path = infolink.url;
      }
    }

    let pseudolink = _parseLinkConfig(_dot(productData.metafields,`config.options_${i+1}_pseudo`));
    if (pseudolink) { 
      let pseudo = fieldset.querySelector('.pseudo-link');
      if(!pseudo) {
        let pseudo = document.createElement('div');
        pseudo.classList.add('pseudo-link');
        pseudo.innerHTML = pseudolink.label;
        pseudo.addEventListener('click',_loadMBPopup);
        pseudo.dataset.path = pseudolink.url;
        fieldset.appendChild(pseudo);
      }
    }
  });

  pi.querySelectorAll('.icon-with-text a').forEach((a) => {
    let url = new URL(a.href);
    if (url.pathname && url.pathname.match(/^\/(pages|products)\//)) {
      if (a.hasAttribute('mb-regulated')) { return; }
      a.setAttribute('mb-regulated',true);
      a.addEventListener('click',(e)=> {
        e.stopPropagation();
        e.preventDefault(); 
        const popup = MBPopup.create();
        popup.load(url.pathname);
      });
    }
  });

}

function _mbDetermineVariantExclusions(pi, productData) {
  const variants = _dot(productData,'product.variants');
  if (!variants || variants.length == 1) { return; }
}; 

function _mbRegulateVariantInfo(pi, productData) {
  const selectedVariant = _getSelectedVariant(pi, productData);
  if (!selectedVariant) { return; }
  let vmetas = _dot(productData,['variant_metafields',selectedVariant.id]);
  if (!vmetas) { return; }

  const descElem = pi.querySelector('.product__description'); 
  if (descElem) { 
    descElem.classList.add('mb-regulated-description');

    //descElem.innerHTML = vmetas.description || _dot(productData,'product.description');
    const htmlString = vmetas.description || '<div class="metafield-rich_text_field">' + _dot(productData,'product.description') + '</div>';
    
    // Convert the richtext into an html tag
    const richTag = _elementFromHTML(htmlString);
    
    const sections = _mbSplitRichTextIntoSections(richTag);
    if (sections.length == 0) {
      sections.push({ title: "Description", html: richTag.innerHTML, isFirst: true });
    }

    // Take the sections and generate detail tags to house them
    descElem.innerHTML = '';
    sections.forEach((section) => {
      const detailsElem = _add(descElem, 'details', { class: "mb-description-section" });
      const summaryElem = _add(detailsElem, 'summary');
      summaryElem.innerHTML = section.title;
      const contentElem = _add(detailsElem, 'div', { class: "mb-description-content rte" });
      contentElem.innerHTML = section.html;
      if (section.isFirst) { detailsElem.open = true; }
    });

  }

  const titleElem = pi.querySelector('variant-selects');
  let shipsElem = pi.querySelector('.product__ships');
  if (titleElem) {
    if (!shipsElem) { 
      shipsElem = _elementFromHTML(MB_SHIPS_HTML);
      titleElem.insertAdjacentElement('beforebegin',shipsElem);
    }
    const ships = _parseShipsConfig(vmetas.ships || _dot(productData,'metafields.ships'));
    if (ships && ships.message.length > 0) {
      shipsElem.innerHTML = ships.message;
      shipsElem.setAttribute('priority',ships.priority);
    } else {
      shipsElem.innerHTML = '';
    }
  }
}

function _mbRegulateFormSubmit(pi, productData) {
  const productForm = pi.querySelector('product-form');
  if (!productForm) { return; }
  const submitButton = productForm.querySelector('button'); 
  if (!submitButton || submitButton.classList.contains('regulated')) { return; }

  submitButton.classList.add('regulated'); 
  submitButton.addEventListener('click', (evt) => {
    evt.stopPropagation();
    evt.preventDefault();

    const selectedVariant = _getSelectedVariant(pi, productData);
    const bundles = pi.querySelectorAll('mb-bundle');

    const vmetas = _dot(productData,['variant_metafields',selectedVariant.id]) || {};
    const ships = _parseShipsConfig(vmetas.ships || _dot(productData,'metafields.ships'));
    const mainItem = { id: selectedVariant.id, quantity: 1 }; 
    if (ships && ships.priority == "high") { _dot(mainItem, "properties.Note", ships.message); }

    let abort = false; 
    const items = [mainItem]; 
    bundles.forEach((bundle) => {
      if (!bundle.isExcluded()) {
        if (bundle.isComplementary()) {
          _dot(mainItem, "properties._complementary", bundle.title);
        }
        if (!bundle.isEnabled() || !bundle.isPurchasable()) { return; }
        const variant = bundle.selectedVariant();
        if (!variant.available) { return; }
        const item = { id: variant.id, quantity: 1, properties: { _gid: selectedVariant.sku } };
        bundle.eachProperty((key, value, pe) => { 
          item.properties[key] = value; 
          if (pe.getAttribute("required")  && !pe.reportValidity() ) {
            abort = true; 
            return false;
          }
        });
        items.push(item);
      }
    });

    if (abort) { return; }

    productForm.handleErrorMessage();
    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');
    productForm.querySelector('.loading__spinner').classList.remove('hidden');

    _mbAddToCart(items.reverse(), 
    (cartData) => {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        productVariantId: mainItem.id,
        cartData: cartData,
        sectionId: pi.dataset.section,
      });
    },
    (cart)=>{
      submitButton.classList.remove('loading');
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      submitButton.removeAttribute('aria-disabled');
      productForm.querySelector('.loading__spinner').classList.add('hidden');
    });
  }); 
}

function _mbRegulateInstallments(pi) {
  const installmentsElem = pi.querySelector(`#product-form-installment-${pi.dataset.section}`); 
  const submitForm = pi.querySelector('product-form');
  if (!installmentsElem || !submitForm) { return; }
  installmentsElem.classList.add('mb-moved');
  // let installmentsWrapper = installmentsElem.parentElement; 
  // let submitWrapper = submitForm.parentElement;
  // submitWrapper.after(installmentsWrapper);
}

function _mbRegulateElements(pi, elementConfig) {
  const selectedVariant =_getSelectedVariant(pi);
  if (!selectedVariant || !elementConfig) { return; }
  let matching = elementConfig.rules.filter((rule) => {
    const type = _dot(rule,"trigger.type"); 
    const filter = _dot(rule,"trigger.filter");
    const match = type == "sku" && selectedVariant.sku.match(filter);
    if (!match) {  
      _revertElementRule(rule, elementConfig);
    }
    return match;
  }); 
  matching.forEach((rule) => { _applyElementRule(rule, elementConfig); });
}

function _mbRegulateWidgets(pi, productData) {
  const selectedVariant = _getSelectedVariant(pi, productData);
  if (!selectedVariant) { return; }
  const vmetas = _dot(productData,['variant_metafields',selectedVariant.id]);
  if (!vmetas) { return; }
  
  let shortsElem = pi.querySelector('.product__shorts');
  if (!shortsElem) { return }

  const sliderElem = _elementFromHTML(MB_SLIDER_HTML);
  shortsElem.replaceChildren(sliderElem); 
  const railElem = sliderElem.querySelector('.mb-slider-rail');
  const shorts = vmetas.short_media || [];
  shorts.map((short, index) => {
    let previewElem = _elementFromHTML(short.preview);
    let slideElem = _elementFromHTML(`<div class="mb-slider-slide"></div>`);
    railElem.appendChild(slideElem);
    slideElem.appendChild(previewElem);
    slideElem.addEventListener('click',()=>{ _presentShortsInPopup(shorts, index); });
    if (previewElem.play) { previewElem.play(); }
  });
}

function _mbRegulateBundles(pi, productData) {
  const parentVariant = _getSelectedVariant(pi, productData);
  if (!parentVariant) { return; }
  const pmetas = productData.metafields;
  const vmetas = _dot(productData,['variant_metafields',parentVariant.id]);
  const inlineBundles = pmetas.inline_bundles || [];
  
  let bundlesElem = pi.querySelector('.product__upsells');
  if (!bundlesElem || !bundlesElem.dataset.useBundles || bundlesElem.dataset.useBundles === 'false') { return }
   
  if (!bundlesElem.dataset.populated) { 
    bundlesElem.dataset.populated = true;
    const qam = pi.closest('quick-add-modal');
    inlineBundles.forEach((bundle) => {
      if (!bundle.product?.id) { return; }
      let bundleElem = _elementFromHTML(MB_BUNDLE_HTML);
      bundlesElem.appendChild(bundleElem);
      bundleElem.populate(bundle);
      bundleElem._moneySample = productData.moneySample;
      if (bundle.default_on) { bundleElem.enable(); }
      bundleElem.addEventListener('change',(evt)=>{ 
        const variant = bundleElem.selectedVariant();
        if (!variant) { return; }
        const media =  bundleElem.isEnabled() ? _mbFilterMedia(bundleElem.product.media, variant.sku, variant.id) : [];
        const gallery = pi.querySelector(`#MediaGallery-${pi.dataset.section}`);
        if (!qam) { _mbPlaceGalleryMedia(gallery, media) };
        _mbRegulateATCDisplay(pi, productData);
      });
    });
  }

  const inlineMap = {};
  vmetas.bundle_variant_configs.forEach((bvc) => {
    const vconfs = _reg(inlineMap, bvc.product_id, []);
    vconfs.push(bvc);
  });
  
  const mbBundles = bundlesElem.querySelectorAll('mb-bundle');
  const exclusionSet = new Set(vmetas.bundle_exclusions);
  let bundleCount = 0;
  mbBundles.forEach((mbBundle) => {
    mbBundle._parentSku = parentVariant.sku;
    const vconfs = inlineMap[mbBundle.product.id];
    mbBundle.filter(vconfs);
    const excluded = exclusionSet.has(mbBundle.info.id);
    mbBundle.dataset.excluded = excluded;
    if (!excluded) { 
      mbBundle.dataset.gid = parentVariant.sku;
      bundleCount++;
    }
  });
  bundlesElem.dataset.count = bundleCount; 
}

function _mbRegulateATCDisplay(pi, productData) {
  const productForm = pi.querySelector('product-form');
  if (!productForm) { return; }
  const submitButton = productForm.querySelector('button'); 
  if (!submitButton || submitButton.hasAttribute('disabled')) { return; }

  const bundles = pi.querySelectorAll('mb-bundle');
  if ((!bundles || !bundles.length)) { return; }
  
  const selectedVariant = _getSelectedVariant(pi, productData);
  const items = [selectedVariant]; 

  bundles.forEach((bundle) => {
    if (!bundle.isPurchasable()) { return; }
    const variant = bundle.selectedVariant();
    if (!variant.available) { return; }
    items.push({price: parseInt(bundle.dataset.price) || 0});
  });

  let total = 0;
  let count = 0;
  items.forEach((item) => { total += parseInt(item.price) || 0; count++; });
  const span = submitButton.querySelector('span');
  if (span) {
    span.innerHTML = (count > 1 ? `Add ${count} items to cart` : "Add to cart") + "<aside>" + mbFormatPrice(total, productData.moneySample) + "</aside>";
  } 
}

const _mbRegulateSections = function(pi, productData) {
  const selectedVariant = _getSelectedVariant(pi, productData);
  if (!selectedVariant) { return; }
  const skuMatchElems = document.querySelectorAll('.mb-sku-match');
  skuMatchElems.forEach((elem) => {
    const matchSku = elem.dataset.skuMatch;
    if (!matchSku) { return; }
    const sectionElem = elem.closest('.shopify-section');
    if (!sectionElem) { return; }
    const regexSkus = matchSku.split(',').map((s) => s.trim());
    const match = regexSkus.some((regex) => {
      try {
        return selectedVariant.sku.match(regex);
      } catch (e) {
        console.error("Invalid regex in mb-sku-match: ", regex, e);
        return false;
      }
    });
    if (match) {
      sectionElem.classList.remove('hidden');
    } else {
      sectionElem.classList.add('hidden');
    }
  });
}

const _filterProductVariants = function(pi, productData) {
  const selectedVariant = _getSelectedVariant(pi, productData);
  if (!selectedVariant) { return; }
  const variants = productData.product.variants; 
  const subvariants = variants.filter((variant, i) => {
    const vmetas = _dot(productData.variant_metafields, variant.id);
    if (variant.id == selectedVariant.id) { return true; }
    return !vmetas || !vmetas.force_hide;
  });
  return subvariants
}

const _getSelectedVariant = function(pi, productData) {
  return _dot(productData,'product.variants.length') == 1 ? productData.product.variants[0] : pi.getSelectedVariant(pi);
}

const _presentShortsInPopup = function(shorts, slideIndex) {
  const sliderElem = _elementFromHTML(MB_MEDIA_SLIDER_HTML);
  const railElem = sliderElem.querySelector('.mb-slider-rail');
  shorts.map((short) => {
    let mainElem = _elementFromHTML(short.main);
    let slideElem = _elementFromHTML(`<div class="mb-slider-slide"></div>`);
    railElem.appendChild(slideElem);
    slideElem.appendChild(mainElem);
  });
  const popup = MBPopup.create();
  popup.content.innerHTML = ''; 
  popup.content.appendChild(sliderElem);
  popup.classList.add('frameless');
  setTimeout(() => { sliderElem.playAtIndex(slideIndex);},10);
}

const _revertElementRule = function(rule, elementConfig) {
  _traverseElementRuleElements(rule, elementConfig, (element) => {
    rule.classes.forEach((cls) => { element.classList.remove(cls); });
  });
}

const _applyElementRule = function(rule, elementConfig) {
  _traverseElementRuleElements(rule, elementConfig, (element) => {
    rule.classes.forEach((cls) => { element.classList.add(cls); });
  }); 
}

const _traverseElementRuleElements = function(rule, elementConfig, cb) {
  if (!cb) { return; }
  rule.selectors.forEach((selector) => {
    if (selector.match("^section:")) {
      const section = elementConfig.sections[selector.split(":")[1]]; 
      if (section) { cb(section) };
    } 
    else {
      const elements = document.querySelectorAll(selector);
      elements.forEach((element) => { cb(element); });
    }; 
  });
}

const _parseLinkConfig = function(str) {
  if (!str) { return };
  let parts = str.split(':');
  return { label: parts.pop(), url: parts.join(':') };
}; 

const _parseShipsConfig = function(str) {
  if (!str || !str.length) { return };
  let parts = str.split('|');
  let priority = parts.length > 1 ? parts.pop().trim().toLowerCase() : undefined;
  return { message: parts.join('|'), priority: priority || "high" };
}

const _observeVisibleVideo = function() {
  var videos = document.querySelectorAll(".image-with-text__media video, .banner__media--video video");
  if (window.IntersectionObserver) {
    if (!window.MBVideoObserver) {
      window.MBVideoObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          const video = entry.target;
          if (entry.isIntersecting) {
            const media = video.parentElement;
            if (media.classList.contains("media")) { 
              media.classList.add('playing'); 
            } 
            video.play();
          } else {
            video.pause();
          }
        });
      });
    }
    videos.forEach((video) => {
      if (video.hasAttribute("observing")) {return}
      video.setAttribute("observing","");
      window.MBVideoObserver.observe(video);
    });
  }
}

function _variantsOptionTree(variants) {
  if (!variants || !variants.length) { return; }
  let optionTree = {};
  variants.forEach((variant) => {
    const options = _deepCopy(variant.options) || variant?.name.split(' - ').pop().split(' / ') || []; 
    const lastOption = options.pop();
    branch = optionTree; 
    options.forEach((option) => {
      if (!branch[option]) { branch[option] = {}; }
      branch = branch[option];
    });
    branch[lastOption] = variant;
  });
  return optionTree;
}

function _findFirstValidOptions(selectedOptions, optionTree) {
  let option = selectedOptions[0]; 
  let validOptions = [option];
  branch = optionTree[option]; 
  for (let i = 1; i < selectedOptions.length; i++) {
    option = selectedOptions[i]; 
    if (!branch[option]) { 
      option = Object.keys(branch)[0]; 
    } 
    validOptions.push(option);
    branch = branch[option];
  }  
  return validOptions
}

function _optionsForVariantSelects(vs) {
  const options = []; 
  vs && vs.selectedOptionValues?.map((optionId) => {
    const elem = vs.querySelector(`*[data-option-value-id="${optionId}"]`); 
    options.push(elem ? elem.value : null);
  });
  return options; 
}

function _setVariantSelectsOptions(vs, options) { 
  if (!vs || !options || !options.length || options.length < 1) { return; }
  const fieldsets = vs && vs.querySelectorAll('fieldset');
  options.forEach((option, i) => {
    const fieldset = fieldsets[i]; 
    const elem = fieldset && fieldset.querySelector(`input[value='${option}']`);
    if (elem && !elem.checked) { 
      elem.click();
    }
  });
}

function _mbRegulateVariantSelectsOptions(vs, options, optionTree) {
  if (!vs || !options || !options.length || options.length < 1) { return; }
  const fieldsets = vs.querySelectorAll('fieldset');

  // Get the root branch 
  let branch = optionTree; 

  // Handle radio buttons
  for (let i = 0; i < options.length; i++) {
    const fieldset = fieldsets[i];
    const inputs = fieldset.querySelectorAll('input');
    inputs.forEach((input) => {
      if (!branch[input.value]) {
        input.classList.add('abberation');
      } else {
        input.classList.remove('abberation');
      }
    });
    branch = branch[options[i]];
  }

  // Check the last option to see if any available variants
  let availableCount = 0
  const lastFieldset = fieldsets[fieldsets.length - 1];
  if (lastFieldset) {
    const inputs = lastFieldset.querySelectorAll('input');
    inputs.forEach((input) => {
      const inputDisabled = input.classList.contains('disabled') || input.classList.contains('visually-disabled');
      const inputAbberation = input.classList.contains('abberation');
      if (!inputDisabled && !inputAbberation) {
        availableCount++;
      }
    });
  }
  vs.dataset.showsAvailable = availableCount > 0;
}

function arePrimitiveArraysEqual(arr1, arr2) {
  return JSON.stringify(arr1) === JSON.stringify(arr2);
}

async function _fetcShopifyData(path) {
  try {
    const response = await fetch(`${window.location.origin}${path}.json`);
    return await response.json();
  } catch (error) {
    return console.error('Error fetching data:', error);
  }
}

function _parseSectionsJSON(sections) {
  const map = {};
  const extractJSONFromHTML = (htmlString) => {
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(htmlString, "text/html");
    const scriptTag = htmlDocument.querySelector('script[type="application/json"]');
    const raw = scriptTag.textContent.trim(); 
    //console.log(`_parseSectionsJSON: ${raw}`);
    return scriptTag ? JSON.parse(raw) : null;
  };
  for (const [key, value] of Object.entries(sections)) {
    if (typeof value === "string") {
      const json = extractJSONFromHTML(value);
      if (json) { map[key] = json; }
    }
  }
  return map;
}

async function _shopifyFetch(path, cfg) {
  try {
    const url = new URL(`${window.location.origin}${path}`);
    if (cfg) { cfg(url); }
    const response = await fetch(url.toString());
    return await response.json();
  } catch (error) {
    return console.error('Error fetching data:', error);
  }
}


function _elementFromHTML(html) {
  const parser = new DOMParser();
  const parsedHTML = parser.parseFromString(html,'text/html');
  return parsedHTML.body.firstElementChild;
}

function _loadMBPopup(event) {
  const target = event.target;
  const path = target.dataset.path;
  if (!path) { return }; 
  const popup = MBPopup.create();
  popup.load(path);
}

const _configAutoplayVideo = function(video) {
  if (video) {
    video.setAttribute('muted','muted');
    video.setAttribute('playsinline','playsinline');
    video.setAttribute('autoplay','true');
    video.setAttribute('loop','loop');
    video.setAttribute('preload','auto');
    video.removeAttribute('controls');
  }
  return video;
}

const _configSwatchElement = function(elem, swatch = {}) {
  if  (!elem) { return; }
  if (swatch.color) { elem.style.backgroundColor = swatch.color; }
  if (swatch.image) { elem.style.backgroundImage = `url(${swatch.image})`; }
  if (swatch.color || swatch.image) { 
   return true; 
  }
  return false;
}

const _aggrItemSkus = function(items) {
  const aggr = {};
  items.forEach((item, i) => {
    _reg(aggr, item.sku, 0);
    aggr[item.sku] += item.quantity;
  });
  return aggr;
}

const _maxItemGidQantity = function(item, aggrs = {}) {
  let max = item.quantity;
  if (item.properties && item.properties._gid) {
    max = Math.min(max, aggrs[item.properties._gid] || 0);
  }
  return max;
}

const _mbAddToCart = function(items, onDone, onFinally) {
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const renderSections = cart ? cart.getSectionsToRender().map((section) => section.id) : []; 
  fetch(window.Shopify.routes.root + `cart/add.js?sections=${renderSections.join(",")}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({items:items})
  })
  .then(response => response.json())
  .then(data => {
    if (onDone) { onDone(data, cart); }
    if (cart && data.sections) { cart.renderContents(data); }
    if (data.status && data.status >= 400) {
      alert(data.description || 'There was an error adding the item to the cart.');
    } else if (cart) { cart.renderContents(data); }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(() => {
    if (onFinally) { onFinally(cart); }
  });
}

const _mbUpdateCart = function(updates, onDone, onFinally) {
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const renderSections = cart ? cart.getSectionsToRender().map((section) => section.id) : []; 
  const body = JSON.stringify({updates: updates, sections:renderSections.join(",")});
  fetch(window.Shopify.routes.root+'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: body
  })
  .then(response => response.json())
  .then((data) => {
    if (onDone) { onDone(data, cart); }
    if (cart) { 
      cart.renderContents(data); 
      cart.classList.toggle('is-empty',!data.item_count);
    }
  }).catch((e) => {
    console.log("CART ERROR: ", e);
  }).finally(() => {
    if (onFinally) { onFinally(cart); }
  });
}

const _mbInjectIncartBundles = function(incarts) {
  console.log("Injecting incart bundles: ", incarts);
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if (!cart || !incarts || !incarts.length) { return; }
  incarts = incarts.filter((incart) => _dot(incart,'info.product.available'));
  if (!incarts.length) { return; }
  let incartUpsells = cart.querySelector('.product__upsells');
  if (incartUpsells) { return; }
  const cartItemsElem = cart.querySelector('cart-drawer-items');
  incartUpsells = _add(cartItemsElem, 'div', { class: 'product__upsells' });
  _add(incartUpsells, 'h3', { class: 'product__upsells-title', html: 'You may also like' });
  let ctr = 0;
  incarts.forEach((incart) => { 
    let bundleElem = _elementFromHTML(MB_CART_BUNDLE_HTML);
    incartUpsells.appendChild(bundleElem);
    bundleElem.populate(incart.info);
    bundleElem.filter(incart.vconfs);
    bundleElem.dataset.gid = incart.gid;
    bundleElem.enable();
    ctr++;
  });
  if (ctr > 0) {
    setTimeout(() => { incartUpsells.classList.add('visible') }, 10); 
    setTimeout(() => { 
      incartUpsells.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 1250); 
  }
}

const _mbFilterMedia = function(media, sku, vId) {
  if (!sku) { return media; }
  return media.filter(m => _mbAltIncludesSku(m.alt, sku, vId));
}

const _mbAltIncludesSku = function(alt, sku, id) {
  if (!alt || !sku) { return true; }
  const parts = _mbAltSkus(alt); 
  const negs = parts.filter((p) => p.startsWith('!'));
  if (negs.length > 0) {
    let nset = new Set(parts);
    return !nset.has(`!${sku}`);
  }
  const pset = new Set(parts);
  return (pset.has(sku) || pset.has(id));
}

const _mbAltSkus = function(alt) {
  if (!alt) { return []; }
  const parts = alt.split(RGX_PIPE_DELIM);
  if (parts.length < 2) { return []; }
  return parts.pop().split(RGX_COMMA_DELIM);
}

const _mbPlaceGalleryMedia = function(gallery, media) {
  const map = {};
  const placed = new Set();
  media.forEach((m) => { 
    let vals = _mbParseAlt(m.alt);
    if (vals.key) {
      _reg(map, vals.key,[]).push({...vals, media:m}); 
    }
  });
  let firstVisibleLi = null;
  const images = gallery.querySelectorAll('img');
  images.forEach((img) => {
    const alt = img.getAttribute('alt'); 
    const vals = _mbParseAlt(alt);
    const umeds = map[vals.key];
    let match = null;
    if (umeds) {
      const skus = img.dataset.filter ? img.dataset.filter.split(RGX_COMMA_DELIM) : []; 
      for (let i=0; i<umeds.length; i++) {
        const u = umeds[i];
        for (let j=0; j<skus.length; j++) {
          const s = skus[j];
          if (u.set.has(s)) {
            match = u;
            break;
          }
        }
        if (match) { break; }
      }
    }
    if (match) {
      let matchSrc = match.media.src || _dot(match.media,'preview_image.src');
      _mbRegAttr(img, 'original-src', img.src);
      img.src = matchSrc;
      img.removeAttribute('srcset');
      placed.add(img)
      if (!firstVisibleLi) { 
        const li = img.closest('li'); 
        if (li && !li.classList.contains('hidden') && li.hasAttribute('data-media-position')) { firstVisibleLi = li; }
      }
    }
    else if (img.getAttribute('original-src')) { 
      img.src = img.getAttribute('original-src'); 
    }
  });
  setTimeout(() => {
    if (firstVisibleLi && window.innerWidth < 750) {
      //gallery.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
    let currentImg = gallery.querySelector('button[aria-current="true"] img');
    if (currentImg && placed.has(currentImg)) { return }
    let button = firstVisibleLi ? firstVisibleLi.querySelector('button') : null;
    if (button) { button.click(); }
  }, 500);
}

const _mbParseAlt = function(alt) {
  let vals = {}
  if (!alt) { return vals; }
  const parts = alt.split(RGX_PIPE_DELIM);
  vals.csv = parts.length > 1 ? parts.pop().trim() : undefined;
  vals.set = new Set(vals.csv ? vals.csv.split(RGX_COMMA_DELIM) : undefined);
  vals.key = parts[0].trim().toLowerCase().replace(RGX_MULTI_SPACE," ");
  return vals;
}

const _mbRegAttr = function(elem, attr, val) {
  if (!elem || !attr) { return; }
  if (!elem.hasAttribute(attr)) { elem.setAttribute(attr, val); }
}

function _mbRegulateBuybar(pi, productData) {
  const buyButton = pi.querySelector(`#ProductSubmitButton-${pi.dataset.section}`);
  if (!buyButton) { return; }
  const buybar = MBBuybar.register();
  buybar.attach(pi, productData);
  setInterval(() => {
    if (buyButton) {
      const rect = buyButton.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) {
        document.body.classList.add('show-buybar');
      } else {
        document.body.classList.remove('show-buybar');
      }
    }
  },1000);
}

function _mbRegulateBYOBProduct() {

  // Set a timer to see when the element with id inlineBYOBProducts is available
  const intervalId = setInterval(() => {
    const inlineBYOBProducts = document.getElementById('inlineBYOBProducts');
    if (inlineBYOBProducts) {
      console.log("Found inlineBYOBProducts element: ", inlineBYOBProducts);
      let cards = inlineBYOBProducts.querySelectorAll('.inline-byob-product-card');
      console.log("Regulating inline BYOB product cards: ", cards.length);
      let indicator = inlineBYOBProducts.querySelector('.loading-indicator');
      if (!indicator && cards.length > 0) {
        clearInterval(intervalId); 

        const optionTreeByProductId = {};

        // Regulate the cards 
        cards.forEach((card) => { 
          // Check the product id 
          const productId = card.dataset.productId;
          let productInfo = PRODUCT_INFO_BY_ID[productId];
          if (productInfo) {
            console.log("Product info found for product id: ", productId, productInfo);
            const pt = card.querySelector('.product-title');
            pt.innerHTML = productInfo.subtitle; 
          } 

          const product = window.bundleManager.findProductById(productId);
          if (product) {
            console.log('Product found for waterfall availability update:', productId, product);
            const tree = _variantsOptionTree(product.variants);
            optionTreeByProductId[productId] = tree;
          }

          let dropdowns = card.querySelectorAll('.custom-variant-dropdown');
          dropdowns.forEach((dropdown, index) => {
            if (index === 0) { 
              // Remove any disabled from the first dropdown options 
              const options = dropdown.querySelectorAll(".dropdown-option");
              options.forEach((option) => {
                option.classList.remove('option-disabled');
                option.style.opacity = '1';
              });
              return ; 
            } // Skip the first dropdown
            const options = dropdown.querySelectorAll(".dropdown-option");
            if (options.length <= 1) {
              dropdown.style.display = 'none';
            }
          }); 
        }); 

        if (window.bundleManager) {
          console.log("****--- Regulating inline BYOB conditions: ", optionTreeByProductId);
          // Override updateDropdownWaterfallAvailability method of updateDropdownWaterfallAvailability
          window.bundleManager.updateDropdownWaterfallAvailability = function(card) {
            const productId = card.dataset.productId;
            const optionTree = optionTreeByProductId[productId];
            const dropdowns = [...card.querySelectorAll(".custom-variant-dropdown")];
            const selectedOptions = dropdowns.map(dropdown => dropdown.querySelector(".dropdown-selected").dataset.value);
            const validOptions = _findFirstValidOptions(selectedOptions, optionTree);
            // Update the dropdowns to reflect valid options
            let branch = optionTree;
            const optionsToClick = []; 
            dropdowns.forEach((dropdown, index) => {
              if (!branch) { return; }
              const options = dropdown.querySelectorAll(".dropdown-option");
              const validOption = validOptions[index];
              options.forEach((option) => {
                const optionValue = option.dataset.value;
                const img = option.querySelector('.dropdown-variant-image');
                if (branch[optionValue]) {
                  option.classList.remove('option-disabled');
                  option.style.opacity = '1';
                  delete img.style.display;
                  if (optionValue == validOption && !option.dataset.selected) { optionsToClick.push(option); }
                } else {
                  option.classList.add('option-disabled');
                  option.style.opacity = '0.5';
                }
              });
              branch = optionTree[validOption];
            });
            // Click the options to select them
            setTimeout(() => {
              optionsToClick.forEach((option) => { option.click() });
            }, 10);
          }; 
        }
      }
    }
  }, 500); // Check every 500 milliseconds

}

function mbFormatPrice(cents, sample='$0.00') {
  const prefixMatch = sample.match(/^[^\d]+/);
  const prefix = prefixMatch ? prefixMatch[0] : '';
  const suffixMatch = sample.match(/[^\d]+$/);
  const suffix = suffixMatch ? suffixMatch[0] : '';
  const numberMatch = sample.match(/[\d.,]+/);
  const numberPattern = numberMatch ? numberMatch[0] : '';
  const decimalMatch = numberPattern.match(/([.,])\d{2}$/);
  const decimalDelimiter = decimalMatch ? decimalMatch[1] : '.';
  const integerPart = decimalMatch
    ? numberPattern.slice(0, numberPattern.lastIndexOf(decimalDelimiter))
    : numberPattern;
  let thousandDelimiter = '';
  if (integerPart) {
    const separators = integerPart.match(/[.,]/g) || [];
    if (separators.length) {
      const unique = Array.from(new Set(separators));
      thousandDelimiter = unique.find((sep) => sep !== decimalDelimiter) || unique[0];
    }
  }
  const value = (cents / 100).toFixed(2);
  let [int, dec] = value.split('.');
  if (thousandDelimiter) {
    int = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousandDelimiter);
  }
  const formattedNumber = int + decimalDelimiter + dec;
  return prefix + formattedNumber + suffix;
}

async function mbRefreshAndShowCartDrawer() {
  const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if (!cartDrawer) { return; }
  try {
    const renderSections = cartDrawer.getSectionsToRender().map((section) => section.id); 
    const response = await fetch(window.Shopify.routes.root + `?sections=${renderSections.join(",")}`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const cartData = await response.json();
    cartDrawer.renderContents({sections: cartData});
    cartDrawer.classList.remove('is-empty'); 
    cartDrawer.open();
  } catch (error) {
    console.error('Error fetching cart data:', error);
  }
}

function _mbSplitRichTextIntoSections(container) {
  const sections = [];
  let currentTitle = 'Description';
  let currentNodes = [];
  let sawLabel = false;
  function commitSection() {
    if (!currentNodes.length) return;
    const wrapper = document.createElement('div');
    currentNodes.forEach(node => wrapper.appendChild(node.cloneNode(true)));
    sections.push({
      title: currentTitle,
      html: wrapper.innerHTML.trim()
    });
    currentNodes = [];
  }
  const children = Array.from(container.children);
  for (const el of children) {
    // Look for a <strong> inside this element
    const strong = el.querySelector('strong');
    const strongText = strong && strong.textContent.trim();
    const isLabel = strong && /:\s*$/.test(strongText); // text ends with a colon
    if (isLabel) {
      commitSection();
      currentTitle = strongText.replace(/:\s*$/, '');
      sawLabel = true;
      continue;
    }
    if (!sawLabel) {
      currentTitle = 'Description';
    }
    currentNodes.push(el);
  }
  // Commit the last section
  commitSection();
  return sections;
}



/**
 * 1LSS - MAGBAK Extension 
 */

VariantSelects.prototype.selectedOptionNames = function(evt) {
  return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
    (input) => input.value
  );
}; 

/**
 * Regulator setup at the very end of the file
 */
Regulator.setup(); 